import Types from "./Types";

const unwrapUserList = (payload) => {
  let current = payload?.data ?? payload;
  while (current && !Array.isArray(current) && current.data != null) {
    current = current.data;
  }
  return Array.isArray(current) ? current : [];
};

const INITIAL_STATE = {
  studentPerGroup: [],
  performance: {},
  videosReport: [],
  homeworkUncomment: [],
  attendancesReport: [],
  examReport: [],
  unpaidReport: [],
  paidReport: [],
  examAttendance: [],
  homeworkAttendance: [],
  homeworkAbsent: [],
  savedMessages: [],
  isLoading: false,
  savedMessagesByReceiverPhone: [],
  savedMessagesByReceiverPhonePagination: {
    currentPage: 1,
    totalPages: 1,
    perPage: 10,
    total: 0,
    from: 0,
    to: 0,
  },
  manualExamMarks: [],
  telegramActiveUsers: [],
  telegramActiveUsersPagination: {
    currentPage: 1,
    totalPages: 1,
    perPage: 15,
    total: 0,
  },
  telegramInactiveUsers: [],
  telegramInactiveUsersPagination: {
    currentPage: 1,
    totalPages: 1,
    perPage: 15,
    total: 0,
  },
  waEvents: [],
  absentStudents: [],
  paymentReport: [],
  paidUnpaidStudents: [],
  paidUnviewedVideos: [],
  studentsNotViewedVideos: [],
  studentsNotEnteredExam: [],
  totalAttendanceByPeriod: [],
  obsoleteNumbers: {
    parentLikePhones: [],
    phonesLessThan14Digits: [],
    phonesInWaEvents: [],
  },
};

export default function reports(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.STUDENTS_PER_GROUP_SUCCESS: {
      return {
        ...state,
        studentPerGroup: payload.data,
      };
    }

    case Types.VIDEO_REPORT_SUCCESS: {
      return {
        ...state,
        videosReport: payload.data,
      };
    }

    case Types.UNPAID_REPORT_SUCCESS: {
      return {
        ...state,
        unpaidReport: payload.data.data,
      };
    }
    case Types.PAID_REPORT_SUCCESS: {
      return {
        ...state,
        paidReport: payload.data.data,
      };
    }
    case Types.ATTENDANCE_REPORT_SUCCESS: {
      return {
        ...state,
        attendancesReport: payload.data.data,
      };
    }

    // create
    case Types.EXAM_REPORT_SUCCESS: {
      return {
        ...state,
        examReport: payload.data?.data,
      };
    }
    case Types.EXAM_ATTENDANCE_SUCCESS: {
      return {
        ...state,
        examAttendance: payload.data,
      };
    }

    case Types.HOMEWORK_ATTENDENCE_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAttendance: payload.data?.data,
      };
    }
    case Types.HOMEWORK_UNCOMMENT_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkUncomment: payload.data?.data,
      };
    }
    case Types.FILTER_HOMEWORK_ATTENDENCE_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAttendance: payload.data?.data,
      };
    }
    case Types.HOMEWORK_ABSENT_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAbsent: payload.data,
      };
    }

    case Types.DELETE_STUDENT_HOMEWORK_SUCCESS: {
      //console.log(payload);
      const newhomeworks = state.homeworkUncomment.filter(
        (item) => item.student_id !== payload.student_id
      );
      return {
        ...state,
        homeworkUncomment: newhomeworks,
      };
    }
    case Types.RESTRICT_STUDENT_HOMEWORK_REQUEST: {
      return {
        ...state,
      };
    }
    case Types.ACCEPT_STUDENT_HOMEWORK_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.COMMENT_STUDENT_HOMEWORK_SUCCESS: {
      const newhomeworks = state.homeworkUncomment.filter(
        (item) => item.id !== payload
      );
      return {
        ...state,
        homeworkUncomment: newhomeworks,
      };
    }
    case Types.STUDENT_PERFORMANCE_SUCCESS: {
      return {
        ...state,
        performance: payload.data,
      };
    }

    case Types.ADD_STUDENT_NOTE_SUCCESS: {
      // Note is added, performance will be refreshed by the saga
      return state;
    }

    case Types.REPORT_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.CENTER_HW_SUCCESS: {
      return {
        ...state,
        centerHw: payload.data,
      };
    }

    case Types.VIDEO_ABSENCE_REPORT_SUCCESS: {
      return {
       ...state,
        videosReport: payload,
      };
    }

    case Types.VIDEO_ABSENCE_REPORT_LOADING: {
      return {
      ...state,
        isLoading: payload,
      };
    }

    case Types.MONTHLY_REPORT_SUCCESS: {
      return {
        ...state,
        monthlyReport: payload,
      };
    }

    case Types.SEND_BULK_CUSTOM_MESSAGE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.SEND_BULK_CUSTOM_MESSAGE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_SAVED_MESSAGES_BY_INTERVAL_SUCCESS: {
      return {
        ...state,
        savedMessages: payload.data?.data || payload.data || [],
      };
    }

    case Types.SEND_SAVED_MESSAGES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.SEND_SAVED_MESSAGES_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_MESSAGES_BY_RECEIVER_PHONE_SUCCESS: {
      return {
        ...state,
        savedMessagesByReceiverPhone: payload.data?.data?.data || payload.data?.data || [],
        savedMessagesByReceiverPhonePagination: {
          currentPage: payload.data?.data?.current_page || 1,
          totalPages: payload.data?.data?.last_page || 1,
          perPage: payload.data?.data?.per_page || 10,
          total: payload.data?.data?.total || 0,
          from: payload.data?.data?.from || 0,
          to: payload.data?.data?.to || 0,
        },
      };
    }

    case Types.GET_MESSAGES_BY_RECEIVER_PHONE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }


    case Types.GET_MANUAL_EXAM_MARKS_SUCCESS: {
      return {
        ...state,
        manualExamMarks: payload.data?.data,
        isLoading: false,
      };
    }

    case Types.GET_MANUAL_EXAM_MARKS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_TELEGRAM_ACTIVE_USERS_SUCCESS: {
      return {
        ...state,
        telegramActiveUsers: payload.data?.users || [],
        telegramActiveUsersPagination: {
          currentPage: payload.data?.meta?.current_page || 1,
          totalPages: payload.data?.meta?.last_page || 1,
          perPage: payload.data?.meta?.per_page || 15,
          total: payload.data?.meta?.total || 0,
        },
        isLoading: false,
      };
    }

    case Types.GET_TELEGRAM_ACTIVE_USERS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_TELEGRAM_INACTIVE_USERS_SUCCESS: {
      return {
        ...state,
        telegramInactiveUsers: payload.data?.users || [],
        telegramInactiveUsersPagination: {
          currentPage: payload.data?.meta?.current_page || 1,
          totalPages: payload.data?.meta?.last_page || 1,
          perPage: payload.data?.meta?.per_page || 15,
          total: payload.data?.meta?.total || 0,
        },
        isLoading: false,
      };
    }

    case Types.GET_TELEGRAM_INACTIVE_USERS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_WA_EVENTS_SUCCESS: {
      const body = payload?.data ?? payload;
      let list = Array.isArray(body)
        ? body
        : body?.data ?? body?.events ?? [];
      if (!Array.isArray(list) && Array.isArray(list?.data)) {
        list = list.data;
      }
      return {
        ...state,
        waEvents: Array.isArray(list) ? list : [],
        isLoading: false,
      };
    }

    case Types.GET_WA_EVENTS_FAIL: {
      return {
        ...state,
        waEvents: [],
        isLoading: false,
      };
    }

    case Types.GET_ABSENT_STUDENTS_SUCCESS: {
      // API returns { code, state, data: [...] }; axios gives response.data = that body
      const body = payload?.data ?? payload;
      const list = Array.isArray(body) ? body : (body?.data ?? []);
      return {
        ...state,
        absentStudents: Array.isArray(list) ? list : [],
      };
    }

    case Types.GET_ABSENT_STUDENTS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.PAYMENT_REPORT_SUCCESS: {
      // API returns { code, state, data: [...] }; axios gives response.data = that body
      const body = payload?.data ?? payload;
      const list = Array.isArray(body) ? body : (body?.data ?? []);
      return {
        ...state,
        paymentReport: Array.isArray(list) ? list : [],
      };
    }

    case Types.PAYMENT_REPORT_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_PAID_UNPAID_STUDENTS_SUCCESS: {
      const body = payload?.data ?? payload;
      const list = Array.isArray(body) ? body : (body?.data ?? []);
      return {
        ...state,
        paidUnpaidStudents: Array.isArray(list) ? list : [],
        isLoading: false,
      };
    }

    case Types.GET_PAID_UNPAID_STUDENTS_FAIL: {
      return {
        ...state,
        paidUnpaidStudents: [],
        isLoading: false,
      };
    }

    case Types.GET_PAID_UNVIEWED_VIDEOS_SUCCESS: {
      const body = payload?.data ?? payload;
      const list = Array.isArray(body) ? body : (body?.data ?? []);
      return {
        ...state,
        paidUnviewedVideos: Array.isArray(list) ? list : [],
        isLoading: false,
      };
    }

    case Types.GET_PAID_UNVIEWED_VIDEOS_FAIL: {
      return {
        ...state,
        paidUnviewedVideos: [],
        isLoading: false,
      };
    }

    case Types.SEND_ATTENDANCE_CUSTOM_MESSAGE_SUCCESS:
    case Types.SEND_ATTENDANCE_CUSTOM_MESSAGE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_STUDENTS_NOT_VIEWED_VIDEOS_SUCCESS: {
      return {
        ...state,
        studentsNotViewedVideos: unwrapUserList(payload),
        isLoading: false,
      };
    }

    case Types.GET_STUDENTS_NOT_VIEWED_VIDEOS_FAIL: {
      return {
        ...state,
        studentsNotViewedVideos: [],
        isLoading: false,
      };
    }

    case Types.GET_STUDENTS_NOT_ENTERED_EXAM_SUCCESS: {
      return {
        ...state,
        studentsNotEnteredExam: unwrapUserList(payload),
        isLoading: false,
      };
    }

    case Types.GET_STUDENTS_NOT_ENTERED_EXAM_FAIL: {
      return {
        ...state,
        studentsNotEnteredExam: [],
        isLoading: false,
      };
    }

    case Types.GET_TOTAL_ATTENDANCE_BY_PERIOD_SUCCESS: {
      return {
        ...state,
        totalAttendanceByPeriod: unwrapUserList(payload),
        isLoading: false,
      };
    }

    case Types.GET_TOTAL_ATTENDANCE_BY_PERIOD_FAIL: {
      return {
        ...state,
        totalAttendanceByPeriod: [],
        isLoading: false,
      };
    }

    case Types.GET_OBSOLETE_NUMBERS_SUCCESS: {
      const body = payload?.data ?? payload;
      const asList = (value) => (Array.isArray(value) ? value : []);
      return {
        ...state,
        obsoleteNumbers: {
          parentLikePhones: asList(body?.parent_like_phones),
          phonesLessThan14Digits: asList(body?.phones_less_than_14_digits),
          phonesInWaEvents: asList(body?.phones_in_wa_events),
        },
        isLoading: false,
      };
    }

    case Types.GET_OBSOLETE_NUMBERS_FAIL: {
      return {
        ...state,
        obsoleteNumbers: {
          parentLikePhones: [],
          phonesLessThan14Digits: [],
          phonesInWaEvents: [],
        },
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}
